import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CardGroup, Container } from "react-bootstrap";
import ComponentSousTitle from "../../layout/ComponentSousTitle";
import ComponentLoader from "../../layout/ComponentLoader";
import { apiGetContribsEspacePrincipalColidee } from "../../../api/ApiColidee";
import ComponentContribution from "./ComponentContribution";
import { MdAddCircleOutline, MdRemoveCircleOutline } from "react-icons/md";

const ComponentVieDeNosMissions = () => {
  const { t } = useTranslation();
  const nbrContributionsMini = 5;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [reduceContributions, setReduceContributions] = useState([]);
  const [contributions, setContributions] = useState([]);
  //const [nomRubrique, setNomRubrique] = useState("Actualités missions");
  const [loader, setLoader] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const recupDatas = async () => {
    setLoader(true);
    // récupération des dernieres contribs sur colidee si ReduxInstance.espacePrincipalColidee est renseigné
    if (ReduxInstance.espacePrincipalColidee !== 0) {
      const form = new FormData();
      form.append("espacePrincipalColidee", ReduxInstance.espacePrincipalColidee);
      const res = await apiGetContribsEspacePrincipalColidee(ReduxToken, form);

      setContributions(res.data);
      /* if (res.data && res.data[0].nomPlateforme) {
        setNomRubrique("Actualités missions - " + res.data[0].nomPlateforme);
      }*/
      const resDataCopy = [...res.data];
      resDataCopy.length = nbrContributionsMini;
      setReduceContributions(resDataCopy);
    }
    setLoader(false);
  };

  const toggleContributions = (etat) => {
    setShowAll(etat);
    const resDataCopy = [...contributions];
    if (!etat) {
      setTimeout(function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
      resDataCopy.length = nbrContributionsMini;
    }

    setReduceContributions(resDataCopy);
  };

  useEffect(() => {
    setShowAll(false);
    recupDatas();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loader && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}
      {!loader && (
        <Container fluid>
          {ReduxInstance.espacePrincipalColidee !== 0 && (
            <>
              <ComponentSousTitle
                nom={t("public.filtres.filtre8")}
                overflowID={"overflowActuMissions"}
              />
              <CardGroup className="overflowContent" id={"overflowActuMissions"}>
                {reduceContributions.map((contribution, index) => (
                  <React.Fragment key={"contribution_" + index}>
                    <ComponentContribution contributionObject={contribution} />
                    {showAll && (index === 15 || index === 30 || index === 49) && (
                      <div
                        role="button"
                        onClick={(e) => toggleContributions(false)}
                        className="seeMoreContributions d-flex align-items-center justify-content-center m-2"
                      >
                        <MdRemoveCircleOutline size="2em" />
                      </div>
                    )}
                  </React.Fragment>
                ))}
                {!showAll && contributions.length > nbrContributionsMini && (
                  <div
                    role="button"
                    onClick={(e) => toggleContributions(true)}
                    className="seeMoreContributions d-flex align-items-center justify-content-center m-2"
                  >
                    <MdAddCircleOutline size="2em" />
                  </div>
                )}
              </CardGroup>
            </>
          )}
        </Container>
      )}
      <br />
      <br />
    </>
  );
};

export default ComponentVieDeNosMissions;
